export default "__VITE_ASSET__B7u2xEKW__"